import React from 'react';
import './FirstDate.css';

const FirstDateComponent = () => {
  return (
    <div className="container-1024">
      <div className="date-tips-area">
        <h3>First Date Tips</h3>
        <div className="date-tips-content">
          <div className="date-tips-center-details">
            <div className="date-tips-section">
              <h4>1. Clarify everyone's expectations.</h4>
              <p>
                Nothing hurts a relationship or friendship more than poor communication! If you are both on the same wavelength you are less likely to get hurt. If you are not on the same wavelength, perhaps its best to wait until you are!
              </p>
            </div>

            <div className="date-tips-section">
              <h4>2. Always use common sense.</h4>
              <p>
                Just because you have known someone online for some time, do not let down your guard any sooner than with a 'traditional' date.
              </p>
            </div>

            <div className="date-tips-section">
              <h4>3. Double date if possible.</h4>
              <p>
                Your best friend is dying for the details anyway! If you judge that to be too awkward, ask if perhaps your best friend might also take in the same activities and kind of keep an eye peeled for you!
              </p>
            </div>

            <div className="date-tips-section">
              <h4>4. ALWAYS conduct early dates in very public places.</h4>
              <p>
                Go to a restaurant in the mall. Go to a club at a hotel. Always be near other people.. If you want to take a walk hand in hand, let it be in the mall. Want the great outdoors? Walk near the surf on a popular beach.
              </p>
            </div>

            <div className="date-tips-section">
              <h4>5. AVOID relying on your date for transportation.</h4>
              <p>
                If you want to end the date or need to end the date, don't be left in the unenviable position of being hostage to transportation. Do not leave your car behind!
              </p>
            </div>

            <div className="date-tips-section">
              <h4>6. Think Ahead.</h4>
              <p>
                Know in advance where police and fire stations are so you know where you can get help if needed. Anticipate some snags, and pre-plan your response.
              </p>
            </div>

            <div className="date-tips-section">
              <h4>7. Never leave your food or beverages unattended.</h4>
              <p>
                Powerful new drugs exist that can make you prey to the other person's wishes and hardly recall anything in the morning. If you start to feel ill, insist on calling a friend or taking a cab if you are too ill to drive home.
              </p>
            </div>

            <div className="date-tips-section">
              <h4>8. Let someone know your plans.</h4>
              <p>
                Tell someone who you are going to be with, including name & phone number. If its convenient, notice your date's license plate number and leave the information on your answering machine at home or with a friend. Agree to be home at a certain hour, or to call someone to let them know you will be late.
              </p>
              <p>
                Now... if you have done your homework, and prepared correctly, both you and your date can relax and have a good time....
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstDateComponent;